import { render } from "./IndicatorInfo.vue?vue&type=template&id=6dbafcde"
import script from "./IndicatorInfo.vue?vue&type=script&lang=js"
export * from "./IndicatorInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__